<template>
  <v-text-field
    :label="label"
    v-model="internalSearchQuery"
    outlined
    dense
    hide-details
    append-icon="eva-search-outline"
    clearable
    background-color="white"
    @keyup.enter="triggerSearchImmediately"
  />
</template>

<script>
export default {
  name: "DebouncedSearchField",
  props: {
    label: {
      type: String,
      required: false,
      default: "Digite para buscar...",
    },
    debounceTimeMs: {
      type: Number,
      required: false,
      default: 500,
    },
  },
  data() {
    return {
      internalSearchQuery: this.value,
      searchTimeout: null,
    };
  },
  watch: {
    internalSearchQuery() {
      this.debounceSearch();
    },
  },
  methods: {
    debounceSearch() {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(
        () => this.triggerSearch(),
        this.debounceTimeMs
      );
    },
    triggerSearchImmediately() {
      clearTimeout(this.searchTimeout);

      this.triggerSearch();
    },
    triggerSearch() {
      this.$emit("input", this.internalSearchQuery);
    },
  },
};
</script>

<style></style>
